export default [
    {
        path: 'relatorio-producao-medico',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-relatorio-producao-medico' */
            '@/views/pronto-atendimento/relatorio-producao-medico/Index'
        ),
        redirect: 'relatorio-producao-medico/index',
        children: [
            {
                name: 'pronto-atendimento-relatorio-producao-medico-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-relatorio-producao-medico' */
                    '@/views/pronto-atendimento/relatorio-producao-medico/List'
                ),
            },
        ]
    }
]